import gsap from "gsap";

export default class Mainvisual {
    constructor() {
        this.isRoopstart = false;
        this._init();
    }

    _init() {
        this.SLIDE_INTERVAL = 4500;

        this.items = [...document.querySelectorAll(".js-mv__imgs__item")];
        this.nrwItems = [...document.querySelectorAll(".js-mv__nrwimgs__item")];
        this.$badge = document.querySelector(".js-mv__badge");
        this.nowIndex = 0;
        this.maxIndex = this.items.length;
        this.timer = null;

        if (location.href.indexOf("?hogosha") > -1) {
            this.items = [this.items[2], this.items[0], this.items[1]];
            this.nrwItems = [this.nrwItems[2], this.nrwItems[0], this.nrwItems[1]];
        }

        window.addEventListener("load", () => {
            if (this.nrwItems && this.nrwItems[0] && this.nrwItems[0].getAttribute("data-badge") === "left") {
                this.$badge.classList.add("-left");
            } else {
                this.$badge.classList.remove("-left");
            }
        });

        this.items[0].classList.add("-active");
        this.nrwItems[0].classList.add("-active");

        this._update();
        this._badge();
    }

    _update() {
        clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            if (!this.isRoopstart) {
                document.body.classList.add("-introend");
                this.isRoopstart = true;
            }

            let index = this.nowIndex + 1;
            if (index >= this.maxIndex) index = 0;

            this._change(index);
            this._update();
        }, this.SLIDE_INTERVAL);
    }

    _change(index) {
        gsap.set(".js-mv__imgs__item", { zIndex: 0 });

        const currentMv = index + 1;
        document.body.setAttribute("data-mv", currentMv);

        // 画像の更新
        const $before = this.items[this.nowIndex];
        const $nrwbefore = this.nrwItems[this.nowIndex];

        const $next = this.items[index];
        const $nrwNext = this.nrwItems[index];

        $before.style.zIndex = $nrwbefore.style.zIndex = 9;
        $next.style.zIndex = $nrwNext.style.zIndex = 10;

        $next.classList.add("-active");
        $nrwNext.classList.add("-active");
        $nrwbefore.classList.remove("-active");

        $next.addEventListener("animationend", (e) => {
            $before.classList.remove("-active");
        });

        // バッジの位置の設定
        if ($nrwNext.getAttribute("data-badge") === "left") {
            this.$badge.classList.add("-left");
        } else {
            this.$badge.classList.remove("-left");
        }

        this.nowIndex = index;
    }

    _badge() {
        var imgs = document.querySelectorAll(".js-mv__nrwimgs__item");
        var badge = document.querySelector(".js-mv__badge");

        for (var i = 0; i < imgs.length; i++) {
            if (imgs[i].classList.contains("-item3") && imgs[i].classList.contains("-active")) {
                badge.classList.add("-left");
                return;
            }
        }

        badge.classList.remove("-left");
    }

    _visibilitychangeHandler() {
        //
    }
}
